import { Divider, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import { resetDataComponent } from "../../../StateManagement/actions";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
import WSButton from "../../../Components/Button/WSButton";
import WSDataGridNew from "../../../Components/DataGrid/WSDataGridNew";
import AddIcon from "@mui/icons-material/Add";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";

export const SymptomsList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const { add, edit, remove } = getPermissions("symptoms"); // role permissions for this page
  const filters = ["All Records"];
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);
  useEffect(() => {
    updateMainHeader("Symptoms");
  });

  breadCrumbsStore.updateBreadCrumbs([{ "Symptoms List": "/symptoms/list" }]);

  const [productSource, setProductSource] = useState<any>({
    url: "Symptoms/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
  });

  const handleFilter = (value: any) => {
    let soureFilter: any = {
      url: "Symptoms/search",
      page: 1,
      pageSize: 10,
      filter: [],
      sort: [
        // {
        //   field: "UpdatedAt",
        //   direction: "desc",
        // },
      ],
    };
    switch (value) {
      case "In Stock":
        soureFilter.filter = [
          {
            field: "name",
            operator: "eq",
            value: "In Stock",
          },
        ];
        break;
        default:
          soureFilter.filter = [
          
        ];
          break;
    }
      setProductSource({ ...soureFilter });
  };
  const source = {
    url: "Symptoms/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
  };

  /**
   *  Edit function
   * @param action
   * @param row
   */
  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/symptoms/edit/${row?.id}`);
    }
    if (action === "Delete") {
      setSelectedId(row.id); // Set the ID of the row to be deleted
      setPopupOpen(true);
    }
  };

  const columns: IColumns[] = [
    {
      header: "Name",
      fieldName: "symptom",
      tooltip: true,
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit && "Edit", remove && "Delete"].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
    },
  ];

  const handleClick = () => {
    navigate("/symptoms/create");
  };

  const handleDelete = (response: any) => {
    dispatch(resetDataComponent("symptomsGrid"));
    showMessage("Symptoms deleted successfully!", "success");
  };

  return (
    <Grid p={3}>
      {/* <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="symptomsGrid"
            title="Symptoms"
            columns={columns}
            source={productSource}
            addButton={add ? { label: "New", color: "secondary" } : undefined}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
          {selectedId !== null && (
            <ConfirmationPopup
             type="DELETE"
              apiUrl={"symptoms"}
              id={selectedId}
              confirmMessage="Are you sure you want to delete this item?"
              open={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              onConfirm={handleDelete}
            />
          )}
        </Grid>
      </Grid> */}
      <Grid container spacing={2}>
        <Grid item sm={9}>
          <WSFilterButtonGroup
            options={filters}
            selected={selectedFilter}
            onChange={(value) => {
              setSelectedFilter(value);
              handleFilter(value);
            }}
          />
        </Grid>
        <Grid item sm={3} display="flex" justifyContent={"flex-end"}>
          <WSButton
            id="btnAddNewProduct"
            label="Add Symptoms"
            startIcon={<AddIcon />}
            onClick={handleClick}
            sx={{
              borderRadius: "999px", // pill shape
              backgroundColor: "#098963!important", // green background
              textTransform: "none", // prevent uppercase
              fontWeight: 500,
              height: "35px!important",
              fontSize: "0.875rem!important",
              paddingX: 3,
              paddingY: 1,
              "&:hover": {
                backgroundColor: "#087654!important",
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          {productSource && (
            <WSDataGridNew
              id="symptomsGrid"
              title="Symptoms"
              columns={columns}
              source={productSource}
              searchBox={{ fieldName: "symptom" }}
              addButton={add ? { label: "New", color: "secondary" } : undefined}
              onAddButtonClick={handleClick}
              gridHeaderSx={{
                backgroundColor: "whitesmoke",
                border: "1px solid whitesmoke",
              }}
            />
          )}
          {selectedId !== null && (
            <ConfirmationPopup
              apiUrl={"symptoms"}
              type="DELETE"
              id={selectedId}
              confirmMessage="Are you sure you want to delete this item?"
              open={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              onConfirm={handleDelete}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
});
